import React, { useState } from "react";
import { Container } from "react-bootstrap";
import { BiSearchAlt2 } from "react-icons/bi";
import MySearchDropDown from "./MySearchDropDown";

const Busqueda = () => {
  const [showMyDropDown, setShowMyDropDown] = useState(false);
  const [mySearch, setMySearch] = useState("");

  const handleDropDown = () => {
    setShowMyDropDown((prev) => !prev);
  };
  
  const handleSearch = (e) => {
    setMySearch(e.target.value);
  };
  const handleGoSearch = ()=>{
    const baseURL = "https://www.miniso.com.mx/";
    const temp = `${baseURL}${mySearch}?_q=${mySearch}&map=ft`;
    
    if (mySearch!=='')
    window.location.assign(temp);
  }
  return (
    <div className="w-100">
      <Container
        onClick={handleDropDown}
        
        style={{ border: "2px solid #ffc4e175", backgroundColor: "#ffc4e125" }}
        className="rounded w-100 d-flex justify-content-between align-items-center p-2"
      >
        <input
          className="border-0 w-100"
          style={{ outline: "none", backgroundColor: "transparent" }}
          value={mySearch}
          onChange={handleSearch}
          type="text"
          placeholder="¿Que estas buscando hoy?"
        />
        <BiSearchAlt2 style={{cursor:'pointer'}} onClick={handleGoSearch} className="fs-4" />
      </Container>
      {showMyDropDown && (
        <Container>
          <MySearchDropDown handleDropDown={handleDropDown} showMyDropDown={showMyDropDown}/>
        </Container>
      )}
    </div>
  );
};

export default Busqueda;
